import React from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { fetchApplicationAndXeroSnapshot } from '/actions/applications';
import { fetchReferrals } from 'actions/referrals';
import { toggleNotification } from '/actions/commonActions';
import { reduxForm, isDirty } from 'redux-form';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import CircularProgress from '@material-ui/core/CircularProgress';
import CalculatorDialog from 'components/Loans/CalculatorDialog';
import heading from 'css/heading';
import LoanSchedule from './LoanSchedule';
import Header from 'components/Header';
import Divider from '@material-ui/core/Divider';
import _ from 'lodash';
import AlertDialog from 'components/AlertDialog';
import XeroDetails from './XeroDetails';
import OnlineFormDetails from './OnlineFormDetails'
import { CheckboxAlertDialog } from '../FormComponents';
import ActionButtons from './ActionButtons';

const styles = {
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  appBar: {
    position: 'static'
  },
  spinnerWrapper: {
    height: '40px',
    position: 'absolute',
    left: '50%',
    top: '50%',
  }
}

class Application extends React.Component {
  componentDidMount = () => {
    const { match, dispatch } = this.props;
    dispatch(fetchApplicationAndXeroSnapshot(match.params.appNumber));
    dispatch(fetchReferrals());
  };

  renderSpinner = () => {
    if (this.props.showSpinner) {
      return (
        <div className={this.props.classes.spinnerWrapper}>
          <CircularProgress color='primary' thickness={9} />
        </div>
      );
    }
    return (<div className={this.props.classes.spinnerWrapper}></div>);
  }

  renderNotification = () => {
    if (this.props.notificationMsg) {
      return (
        <Snackbar
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          open={!!this.props.notificationMsg}
          onClose={()=>{this.props.dispatch(toggleNotification())}}
          message={<span id='message-id'>{this.props.notificationMsg}</span>}
        />
      );
    }
  }

  renderStatus = () => {
    return (
      <Typography variant='subheading' color='secondary' gutterBottom>
        {`Status: ${this.props.application.status}`}
      </Typography>
    );
  }

  renderMessage = () => {
    if (this.props.dirty) {
      return (
        <Typography variant='subheading' color='secondary' gutterBottom>
          Application has been changed, please click on 'UPDATE' to save the change(s).
        </Typography>
      );
    }
  }

  renderSchedules = () => {
    if (!this.props.dirty && this.props.application.status === 'quoted') {
      return (
        <LoanSchedule quote={this.props.quote} schedules={this.props.schedules} />
      );
    }
  }

  renderButtons = () => {
    const { dirty, dispatch, application, history } = this.props;
    const actionBtns = new ActionButtons({dirty, dispatch, application, history})
    return (
      <div>
        <Header heading='Actions' />
        <br />
        { this.renderMessage() }
        { this.renderSpinner() }
        <div style={heading.buttonGroup}>
          { actionBtns.renderBtns() }
        </div>
      </div>
    )
  }

  renderApplicationForm = () => {
    if (['online_form', 'referral'].includes(this.props.application.appType)) {
      return this.renderOnlineApplicationForm();
    } else {
      return this.renderXeroApplicationForm();
    }
  }

  renderOnlineApplicationForm = () => {
    return (
      <OnlineFormDetails
        application={this.props.application}
        referrals={this.props.referrals}
        industry={_.get(this.props.application, 'form.industry')}
      />
    );
  }

  renderXeroApplicationForm = () => {
    if (this.props.xeroSnapshot) {
      return (
        <XeroDetails
          xeroSnapshot={this.props.xeroSnapshot}
          organisationId={this.props.application.organisationId}
        />
      );
    }
  }

  render = () => {
    const { application } = this.props;
    if (!application) {
      return null;
    }
    return (
      <div className={this.props.classes.root}>
        <Typography variant='headline' gutterBottom>
          {`Application Number: ${application.number}`}
        </Typography>
        { this.renderNotification() }
        { this.renderStatus() }
        { this.renderMessage() }
        <Divider />
        <br />
        { this.renderApplicationForm() }
        { this.renderSchedules() }
        <br />
        { this.renderButtons() }
      </div>
    );
  };
}

const mapStateToProps = (state, ownProps) => {
  const appNumber = ownProps.match.params.appNumber;
  const application = state.applications && state.applications[appNumber];
  const referrals = state.referrals.referrals && Object.values(state.referrals.referrals);
  const organisation = application && application.organisation;
  const quotes = application && application.quotes;
  const quote = quotes && _.first([...quotes]);
  const schedules = quote && quote.quoteSchedules;
  const dirty = state.form && state.form.applicationForm && state.form.applicationForm.dirty;
  const xeroSnapshot = state.xeroSnapshot

  return {
    initialValues: application && application.form,
    application,
    referrals,
    notificationMsg: state.app.notificationMsg,
    showSpinner: state.app.showSpinner,
    organisation,
    quote,
    schedules,
    dirty,
    xeroSnapshot
  };
};

const reduxed = reduxForm({ form: 'applicationForm', enableReinitialize: true, dirty: isDirty('applicationForm') })(Application);
const connected = connect(mapStateToProps)(reduxed);
export default withStyles(styles)(connected);



// WEBPACK FOOTER //
// ./src/components/Applications/Application.js